/** Single mission item for Weekly Missions (mock data). */
export interface MissionItem {
  icon: string;
  title: string;
  desc: string;
  xp: number;
  diff: "easy" | "med" | "hard";
  impact: number;
  metric: string;
  detail: string;
}

export const PLH_MISSIONS_MOCK: MissionItem[] = [
  {
    icon: "🔧",
    title: "Slash onboarding to 3 steps",
    desc: "76% drop at signup→setup. Remove optional fields, get to schedule in <90s. Users who invite first never return — flip the order.",
    xp: 500,
    diff: "hard",
    impact: 5,
    metric: "Signup → Setup",
    detail:
      "The biggest lever right now. Every 1% improvement in setup completion = 0.5 more activated users/week. Focus: remove company name field, skip team invite, show empty schedule immediately. Measure: setup completion rate should go from 24% → 50%.",
  },
  {
    icon: "📞",
    title: "Call 4 Schedule Created users",
    desc: "Laura, nana, Gabrielle, Matt all created schedules but didn't convert. Matt at 85% activation.",
    xp: 300,
    diff: "easy",
    impact: 4,
    metric: "Conversions",
    detail:
      "These are your warmest leads. Matt (ShomePower) is closest — 85% activated, 340 scheduled hours. Gabrielle (GNF) has 12 team members already. Both are ICP matches. Prepare: 5-min Loom showing their own schedule data, end with \"want me to publish this for your team?\"",
  },
  {
    icon: "⚡",
    title: 'Add "Publish" nudge post-setup',
    desc: "100% of setup completers generate a schedule, 0% publish. Pure UX gap — add in-app prompt.",
    xp: 400,
    diff: "med",
    impact: 5,
    metric: "Published",
    detail:
      'Every user who completes setup generates a schedule, but the journey stops there. The "publish" action is buried. Add: (1) modal after first schedule save, (2) confetti animation on publish, (3) "Share with team" CTA. This should take <4 hours to ship.',
  },
  {
    icon: "📊",
    title: "Instrument TTFS tracking",
    desc: "Time to First Schedule is unmeasured. Add timestamp delta signup→first save.",
    xp: 200,
    diff: "med",
    impact: 3,
    metric: "TTFS",
    detail:
      "You can't improve what you don't measure. Add: signup_timestamp and first_schedule_saved_timestamp to your events. Calculate delta. Goal: <30 min. This metric will become your primary leading indicator for activation quality.",
  },
  {
    icon: "🧪",
    title: "A/B test SSO prominence",
    desc: "Only 4/14 used SSO but SSO users show 2× activation. Make Google SSO primary.",
    xp: 350,
    diff: "med",
    impact: 4,
    metric: "Signup rate",
    detail:
      "SSO users: 50% activation rate. Email users: 25%. The hypothesis: less friction at signup = better quality signups who actually complete setup. Test: swap SSO above email field for 2 weeks. Measure: signup volume + setup completion rate.",
  },
  {
    icon: "✉️",
    title: "Ship 24h comeback email",
    desc: "19 users never finished setup. Auto email: deep link to where they stopped + \"book setup call\" CTA.",
    xp: 450,
    diff: "hard",
    impact: 5,
    metric: "Setup rate",
    detail:
      'These 19 users showed intent by signing up. At 24h, send: (1) what they\'re missing (personalized), (2) deep link to exact step they stopped, (3) "Book a 10-min setup call" Calendly link. Expected: 15-20% re-engagement → 3-4 additional setups/week.',
  },
];

export const TOTAL_XP = PLH_MISSIONS_MOCK.reduce((s, m) => s + m.xp, 0);

export const LEVELS = ["🌱 Seedling", "🌿 Sprout", "🌳 Grower", "🚀 Rocket", "⭐ PLG Star"];
export const REWARDS = [
  "unlock AI goal suggestions",
  "unlock AI weekly reports",
  "unlock predictive analytics",
  "unlock custom dashboards",
  "you're the PLG legend",
];

/** Last week auto-eval mock items. */
export const LAST_WEEK_ITEMS = [
  { status: "ok" as const, label: "SSO test → signup +38%" },
  { status: "part" as const, label: "Called 2/4 users → 0 paid" },
  { status: "miss" as const, label: "Onboarding not shipped" },
  { status: "ok" as const, label: "Comeback email → 3 re-engaged" },
  { status: "miss" as const, label: "TTFS tracking not started" },
];
